import { render, staticRenderFns } from "./SobreNosotros.vue?vue&type=template&id=b6e3d3d2&scoped=true"
import script from "./SobreNosotros.vue?vue&type=script&lang=js"
export * from "./SobreNosotros.vue?vue&type=script&lang=js"
import style0 from "./SobreNosotros.vue?vue&type=style&index=0&id=b6e3d3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e3d3d2",
  null
  
)

export default component.exports